export const appTexts = {
  appName: 'Operations Tool',
}

export const errorPageTexts = {
  title: 'Something went wrong',
  message: 'An unexpected error occurred. Please refresh the page or try again later.',
}

export const homePageTexts = {
  welcome: 'Welcome',
  subtitle: 'You have signed in successfully. This is the operations-tool skeleton.',
}

export const notFoundTexts = {
  title: 'Page not found',
  message: 'The page you are looking for does not exist.',
  backToHome: 'Go to Home',
}
